import { useNavigate } from 'react-router-dom';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function PromoBanner() {
  const navigate = useNavigate();
  const { ref: leftRef, isVisible: leftVisible } = useScrollReveal();
  const { ref: rightRef, isVisible: rightVisible } = useScrollReveal();

  return (
    <section className="w-full">
      <div className="flex flex-col md:flex-row">
        {/* Left - image area */}
        <div
          ref={leftRef}
          className={`relative w-full md:w-1/2 min-h-[300px] md:min-h-[480px] overflow-hidden scroll-reveal ${leftVisible ? 'scroll-reveal-visible' : ''}`}
        >
          <img
            src="https://readdy.ai/api/search-image?query=new%20hearing%20aid%20product%20launch%20promotion%20modern%20device%20on%20warm%20orange%20gradient%20background%20professional%20product%20photography%20high%20quality%20close%20up%20soft%20lighting&width=800&height=480&seq=31&orientation=landscape"
            alt="新品助聽器上市"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#1B3D2A]/85 via-[#1B3D2A]/40 to-transparent" />
          <div className="absolute top-6 left-6">
            <span className="text-sm text-white/80 font-medium bg-[#1B3D2A]/40 px-3 py-1 rounded-full">
              限時優惠
            </span>
          </div>
          <div className="absolute bottom-6 left-6 right-6">
            <h3 className="text-white text-2xl md:text-3xl font-bold leading-tight">
              全新機款上市
              <br />
              首購限時特惠
              <br />
              全系列加碼補助
            </h3>
          </div>
        </div>

        {/* Right - info area */}
        <div
          ref={rightRef}
          className={`w-full md:w-1/2 bg-[#FAF8F5] flex flex-col items-center justify-center px-6 md:px-12 py-10 md:py-0 min-h-[300px] md:min-h-[480px] scroll-reveal scroll-reveal-delay-2 ${rightVisible ? 'scroll-reveal-visible' : ''}`}
        >
          <span className="inline-block text-xs font-semibold tracking-widest text-[#D4A574] uppercase mb-2">
            優惠活動
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#1B3D2A] text-center leading-tight">
            免費聽力檢測
            <br />
            再享購機補助
          </h2>
          <p className="mt-6 text-[#5A6B5A] text-base md:text-lg text-center leading-relaxed max-w-sm">
            即日起至本月底，凡預約到店完成免費聽力檢測，即可獲得購機現金抵用券，搭配政府助聽器補助方案，最高可省下數萬元。
          </p>
          <button
            type="button"
            onClick={() => navigate('/booking')}
            className="mt-6 md:mt-8 bg-[#1B3D2A] text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-base font-medium hover:bg-[#143026] transition-colors flex items-center gap-2 whitespace-nowrap"
          >
            立即預約諮詢
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-base"></i>
            </div>
          </button>
        </div>
      </div>
    </section>
  );
}